import { service } from '../services/request';

export function getUserById(params: any) {
    return service({
        url: `/api/v1/users/${params.id}`,
        method: 'get',
    });
}
